import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';

import { roundToPreviousPeriod, roundToNextPeriod } from '../util';
import { MINUTES_IN_BLOCK } from  '../components/Common/TimeSelector/TimeGrid';
import TimeSelector from '../components/Common/TimeSelector/TimeSelector';

import { setNewBookingStartTime, setNewBookingEndTime } from '../actions/newBooking';
import { setError } from '../actions/environment';

import {
    UNAVAILABLE_TIMES_DAYS_PRIOR,
    UNAVAILABLE_TIMES_DAYS_FOLLOWING,
    UNAVAILABLE_PRIOR_REASON,
    UNAVAILABLE_FOLLOWING_REASON,
} from '../constants/bookingUnavailability';

const PAST_BOOKING_REASON = `Bookings cannot be created in the past.`;

class CreateBookingTimeSelectorContainer extends Component {
    static propTypes = {
        startTime: PropTypes.object,
        endTime: PropTypes.object,
    }

    constructor(props) {
        super(props);

        const { startTime, endTime } = this.props;
        const roundedNow = roundToNextPeriod(moment(), MINUTES_IN_BLOCK);
        const start = startTime && startTime.isAfter(roundedNow) ? startTime.clone() : roundedNow;
        const end = endTime && endTime.isAfter(start) ? endTime.clone() : start.clone().add(MINUTES_IN_BLOCK, `m`);
        const roundedStart = roundToNextPeriod(start, MINUTES_IN_BLOCK);

        let roundedMinStart = roundedStart.clone().startOf(`d`).subtract(UNAVAILABLE_TIMES_DAYS_PRIOR, `d`);
        let startTimeUnavailabilityReason = UNAVAILABLE_PRIOR_REASON;
        // The minimum start should always be later than now.
        if (roundedMinStart.isBefore(roundedNow)) {
            roundedMinStart = roundedNow.clone();
            startTimeUnavailabilityReason = PAST_BOOKING_REASON;
        }
        // The minimum start should never be after the start time
        if (roundedMinStart.isAfter(roundedStart)) {
            roundedMinStart = roundedStart.clone();
            startTimeUnavailabilityReason = PAST_BOOKING_REASON;
        }

        this.state = {
            initialStart: start,
            initialEnd: end,
            roundedStart: roundedStart,
            roundedEnd: roundToNextPeriod(end, MINUTES_IN_BLOCK),
            roundedMinStart: roundedMinStart,
            roundedMaxEnd: end.clone().startOf(`d`).add(UNAVAILABLE_TIMES_DAYS_FOLLOWING, `d`),
            initialFocusTime: start.clone(),
            startTimeUnavailabilityReasons: [startTimeUnavailabilityReason],
        };

        this.save = this.save.bind(this);
    }

    componentWillMount() {
        // Save the times to the redux state if we have changed them (can happen to handle now() changes)
        if (!this.props.startTime.isSame(this.state.initialStart))
            this.props.setNewBookingStartTime(this.state.initialStart);

        if (!this.props.endTime.isSame(this.state.initialEnd))
            this.props.setNewBookingEndTime(this.state.initialEnd);
    }

    render() {
        return (
            <TimeSelector
                initialStart={this.state.initialStart}
                initialEnd={this.state.initialEnd}
                roundedStart={this.state.roundedStart}
                roundedEnd={this.state.roundedEnd}
                roundedMinStart={this.state.roundedMinStart}
                roundedMaxEnd={this.state.roundedMaxEnd}
                initialFocusTime={this.state.initialFocusTime}
                canEditStart={true}
                canEditEnd={true}
                onSave={this.save}
                hasInstantSave={true}
                title="Booking length"
                startTimeUnavailabilityReasons={this.state.startTimeUnavailabilityReasons}
                endTimeUnavailabilityReasons={[UNAVAILABLE_FOLLOWING_REASON]}
                onUnavailableTimeSlotClicked={this.props.setError}
            />
        );
    }

    save(newStart, newEnd) {
        if (newStart) {
            this.props.setNewBookingStartTime(newStart);
        }

        if (newEnd) {
            this.props.setNewBookingEndTime(newEnd);
        }
    }
};

const mapStateToProps = (state) => {
    const { startTime, endTime } = state.newBooking;
    return {
        startTime,
        endTime
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setNewBookingStartTime,
        setNewBookingEndTime,
        setError
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateBookingTimeSelectorContainer);



// WEBPACK FOOTER //
// ./scripts/containers/CreateBookingTimeSelectorContainer.jsx